import React from 'react';

import GameBadge from '../../../MonthSchedule/GameBadge/GameBadge';
import ToolTip from '../../../Tooltip/Tooltip';
import { GroupedGamePropsType } from '../types';

const GroupedGame = ({ games, half }: GroupedGamePropsType) => {
  
  // const [showToolTip, setShowToolTip] = useState(-1);
  const n = games.length;
  let mh = n;
  let otherGames = games;
  if (n > 6) {
    otherGames = games.slice(0, 6);
    mh = 6;
  }
  const listGames = otherGames.map((game, index) => (
    <GameBadge
      key={index}
      clas='list-game-cards'
      height={198 / mh}
      vertical={(198 - (mh * 22)) / (2 * mh)}
      game={game}
      noHover
    />
    // return(
    //   <div className='little-game'>
    //     <b>{game.homeTeamAbbr}</b> <img src={'/assets/images/logos/'+game.homeTeamAbbr+'.svg'} height="16px" alt="" /> <b>{game.homeTeamScoreTotal}</b>
    //     <span>@</span>
    //     {game.visitorTeamScoreTotal} <img src={'/assets/images/logos/'+game.visitorTeamAbbr+'.svg'} height="16px" alt="" /> {game.visitorTeamAbbr}
    //   </div>
    // );
  ));
  
  return (
    <div className='event-card grouped-game' id='grouped-game-card' style={half ? { marginTop: '33px' } : {}}>
      {listGames}
      {games.length > 6 && (
        <ToolTip
          moreEvents={games.slice(6, n)}
          tooltipData
          margin
          // setShowToolTip={setShowToolTip}
          // showToolTip={showToolTip}
        />
      )}
    </div>
  );
};

export default GroupedGame;
